export enum MonitoringPagesEnum {
  Days = "monitoring-days",
  Tickets = "monitoring-tickets",
  Projects = "monitoring-projects",
}
